import React from 'react';
import {connect} from 'react-redux';
import Button from 'antd/lib/button';
import Tabs from 'antd/lib/tabs';
import Modal from 'antd/lib/modal';
import 'antd/lib/button/style/index';
import 'antd/lib/menu/style/index';
import 'antd/lib/dropdown/style/index';
import 'antd/lib/avatar/style/index';
import 'antd/lib/tabs/style/index';
import 'antd/lib/page-header/style/index';
import 'antd/lib/modal/style/index';
import 'antd/lib/pagination/style/index';
import 'antd/lib/empty/style/index';
import { changeTestStatusModal, createTestModal, saveEntireEvaluatedTest, showGenerateQuesListView, updateListViewType } from 'actions/practiseTest';
import { FaRegEdit, FaRegClone } from "react-icons/fa";
import { MdPublish, MdKeyboardBackspace } from "react-icons/md";
import { AiTwotoneEdit } from "react-icons/ai";
import '../styles.css';
import { Color, Notification } from 'services';
import { Col, Row , Typography} from 'antd';

const { TabPane } = Tabs;
const { confirm } = Modal;
const { Title } = Typography;



function TopNavigationColorHeader ({submittedTestsDetails,
                                    submittedTestsUsers,
                                    submittedTestsStudentsId, 
                                    history, type, generateQuesObj, 
                                    changeTestStatusModal, createTestModal,
                                    listView=false, listViewType, userType, user,
                                    saveEntireEvaluatedTest, selectedCardType, totalQuestions, updateListViewType, submittedTestsByStudentId, showGenerateQuesListView}) {
    console.log('See user.id===generateQuesObj.teacherId and selectedCardType',user.id===generateQuesObj.teacherId,selectedCardType);                                 
    return (
      <div className='r-c-sb p-20' style={{height:60, background:'#F6F4FE'}}>
        <div className='r-ac'>
          <MdKeyboardBackspace onClick={() => history.goBack()} className='text-md color-black m-r-10 cursor-pointer' />

          {type === 'studentAnswer'
          ?
            <div className='r-ac'>
              <div className='text-sm bold-600 color-black'>
                {/* {
                  submittedTestsUsers?.map((item, index) => (
                    item.userId == submittedTestsStudentsId ? item.username : ""
                  ))
                } */}
              </div>
              <div className='text-xs m-l-10 color-black'>{` ${submittedTestsDetails.title} `}</div>
            </div>
          :
            <div className='text-sm bold-600 color-black'>{generateQuesObj.title}</div>
          }
          {((type === 'studentAnswer')||type==='no-edit'||(generateQuesObj.status==='Published'&&userType!='admin'))
          ?
            null
          : listView
            ?
              null
            :
              <AiTwotoneEdit onClick={() => {
                // universalLoader('EDIT_DETAILS_LOADER', 'editDetailsLoader', true);
                updateListViewType('edit');
                showGenerateQuesListView(()=>{
                    // universalLoader('EDIT_DETAILS_LOADER', 'editDetailsLoader', false);
                    createTestModal("test-edit", user, 'navigation');
                }, "navigation");
              }} className='text-md a2grey m-l-20 cursor-pointer' />
          }
        </div>

        {type === 'studentAnswer'
          ? 
            submittedTestsDetails.testType!="Objective" && (submittedTestsByStudentId.submitStatus!=='Graded' || userType==='admin')
            ?
            <Button onClick={() => saveEntireEvaluatedTest(() => {
              history.goBack()
            })} className='blueBtnWrap radius-100 m-l-20 text-xs'>SAVE TEST SCORE</Button>
            :
            null
          :
            <div className='r-ac'>
              {((type=='no-edit')||(listViewType=='no-edit'))
              ?
                selectedCardType=='adminlive'
                  ?
                  null
                  :
                  null
              :
                <>
                  {(generateQuesObj.status==="Draft"||generateQuesObj.status==="Feedback") && (userType=="dataOperator"||(userType==='admin'&&generateQuesObj.authorId===user.id&&generateQuesObj.authorId!==generateQuesObj.teacherId))
                  ?
                  <Button onClick={() => {
                    if (totalQuestions>0){
                    changeTestStatusModal('Review')
                    }
                    else{
                      Notification.error("error", "Cannot send for review without any questions created")}
                  }} className='orangeBtnWrap radius-100 text-xs'>SEND FOR REVIEW</Button>
                  :null}
                  {(generateQuesObj.status==='Review' && (userType=="teacher"||(userType=='admin'&&user.id===generateQuesObj.teacherId&&user.id!==generateQuesObj.authorId))) 
                  ?
                  <Button onClick={() => changeTestStatusModal('Feedback')} className='orangeBtnWrap radius-100 text-xs'>SEND FEEDBACK</Button>
                  :null
                  }
                  {(userType==='teacher'&&(generateQuesObj.status==='Draft'||generateQuesObj.status==='Feedback'||generateQuesObj.status==='Review'))
                  ?
                    <Button onClick={() => {
                      if (totalQuestions>0){
                        changeTestStatusModal('Ready')
                      }
                      else{
                        Notification.error("error", "Cannot Mark as ready without any questions created")
                      }
                      }} className='blueBtnWrap radius-100 m-l-20 text-xs'> Mark as Ready </Button>
                  :
                  null
                  }
                  {(userType=="admin"&&generateQuesObj.status!=='Published')
                  ?
                  <Button onClick={() => changeTestStatusModal('Published')} className='blueBtnWrap radius-100 m-l-20 text-xs'>PUBLISH NOW</Button>
                  :
                  null
                  }
                </>
              }
            </div>
        }

      </div>
  );
}


const mapStateToProps = state => {
  const {generateQuesObj, listViewType, submittedTestsDetails, submittedTestsUsers, submittedTestsStudentsId, userType,
        selectedCardType, totalQuestions, submittedTestsByStudentId } = state.practiseTest;
  const {user} = state.session;
  return {generateQuesObj, listViewType, submittedTestsDetails, submittedTestsUsers, submittedTestsStudentsId, userType, user,
        selectedCardType, totalQuestions, submittedTestsByStudentId};
};

const mapDispatchToProps = dispatch => ({
  changeTestStatusModal: (name) => dispatch(changeTestStatusModal(name)),
  createTestModal: (name, user, source) => dispatch(createTestModal(name, user, source)),
  saveEntireEvaluatedTest: (callback) => dispatch(saveEntireEvaluatedTest(callback)),
  updateListViewType: (type)=> dispatch(updateListViewType(type)),
  showGenerateQuesListView: (callback, type) => dispatch(showGenerateQuesListView(callback, type))
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavigationColorHeader);
